import { PLAN_KEY } from '../../constants'
import { getValueReduxUtil } from '../../../../redux'

function hasStartedPlanUtil (plan) {
  return !!getValueReduxUtil(plan, PLAN_KEY.STARTED_AT)
}

export default hasStartedPlanUtil
